export const routeToPlatformHomePage = () => {
  const protocol = process.env.REACT_APP_DOMAIN_NAME !== 'localhost' ? 'https' : 'http';
  const port = process.env.REACT_APP_DOMAIN_NAME !== 'localhost' ? '' : ':3001';
  return protocol + '://' + process.env.REACT_APP_DOMAIN_NAME + port
}